import { get } from 'lodash';

import Model from 'models';
import Money from 'utils/Money';

const Size = class extends Model {
  get variantId() {
    return get(this._data, 'legacyResourceId');
  }

  get price() {
    return new Money(parseFloat(get(this._data, 'price')) * 100).format();
  }

  get label() {
    return get(this._data, 'title');
  }

  get isAvailable() {
    return get(this._data, 'isAvailable');
  }
};

export default Size;
